export default __webpack_public_path__ + "static/media/interface-4.ec23463f.png";